
import { GoVerified } from 'react-icons/go'
import { GiCancel } from 'react-icons/gi'
import IconEdit from '../../assets/img/icone-edit.svg';
import './styles.css'
const CardPessoa = ({keyg , wasChanged , onClick , name , index} , key) => {

    return (
        <div key={key+'dd'} className="card-aluno">
            <p className='box-text'>
            {wasChanged ? <GoVerified color='green' /> : <GiCancel color='red' />}
                {name}
            </p>
            <div className='box-icons'>
                <button style={{ border: 'none' , backgroundColor:'transparent' }} onClick={onClick}>
                    <div className='icon-card-pessoa' >
                    <img width={'35'} src={IconEdit} alt="" />
                    </div>
                </button>
            </div>
        </div>
    )
}
export default CardPessoa;